import CompanyScreen from './CompanyScreen.js';

export default CompanyScreen;
